import { v4 as uuid } from 'uuid';
import * as zod from 'zod';

export const S3BucketConfiguration = zod.object({
  kind: zod.literal('S3Bucket'),
  id: zod.string().optional(),
  name: zod.string().default('S3 Bucket'),
  connectionOptions: zod
    .object({
      roleArn: zod.string().default(''),
      bucket: zod.string().default(''),
      keyPrefix: zod.string().default(''),
      region: zod.string().default('us-east-1'),
      externalId: zod.string().default(() => uuid()),
    })
    .default({}),
});

export type S3BucketConfiguration = zod.infer<typeof S3BucketConfiguration>;
